export default __webpack_public_path__ + "static/media/loading.923c2628.gif";